import { render, staticRenderFns } from "./404Page.vue?vue&type=template&id=0d51e13b&scoped=true&"
import script from "./404Page.vue?vue&type=script&lang=js&"
export * from "./404Page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d51e13b",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d51e13b')) {
      api.createRecord('0d51e13b', component.options)
    } else {
      api.reload('0d51e13b', component.options)
    }
    module.hot.accept("./404Page.vue?vue&type=template&id=0d51e13b&scoped=true&", function () {
      api.rerender('0d51e13b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layout/404Page.vue"
export default component.exports